import { Component, OnInit } from '@angular/core';
import { ConnexionService } from '@app/modules/connexion/services/connexion.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor(    
  ) { }

  ngOnInit() {
  }

}
